export const waitForCountSessionId = async () => {
    const maxRetries = 3;
    let retryCount = 0;

    return new Promise((resolve) => {
        if (!window?.ka) {
            resolve();
        }

        const tryGetKountSessionId = () => {
            if (window.ka.collectEnd || retryCount > maxRetries) {
                resolve(window.ka.sessionId);
            }
            // eslint-disable-next-line better-mutation/no-mutation
            retryCount++;
            setTimeout(tryGetKountSessionId, 500 * retryCount);
        };
        tryGetKountSessionId();
    });
};
